import { Stack } from '@mantine/core';
import { Title } from '@repo/foundations';
import { useAuthUser } from '../../../api';
import { SearchAi } from '../../../components/Search/SearchAi';
import { getGreeting } from '../utils';

export default function HomePageHeaderAi() {
	const { user } = useAuthUser();
	const title = `${getGreeting()}${user?.first_name ? ',' : ''} ${
		user.first_name
	}`;

	return (
		<Stack align="stretch" spacing="xl">
			<Title size="3xl" align="center">
				{title}
			</Title>
			<SearchAi />
		</Stack>
	);
}
